import { ca } from '@cian/analytics';
import { IAnalyticsProduct, TAnalyticsOfferStatus, IAnalyticsExtraOfferIds } from '../../types/analytics';

interface ITrackNaturalDepositModalOpenParams {
  analyticsOfferStatus: TAnalyticsOfferStatus;
  analyticsProduct: IAnalyticsProduct;
  analyticsExtraOfferIds: IAnalyticsExtraOfferIds;
}

export const trackNaturalDepositLinkClick = (params: ITrackNaturalDepositModalOpenParams) => {
  const { analyticsOfferStatus, analyticsProduct } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'Click',
    label: 'balance',
    products: [analyticsProduct],
    page: {
      pageType: 'AddForm',
      extra: {
        type: 'fvu_newest',
        ...params.analyticsExtraOfferIds,
      },
    },
  });
};

interface ITrackLegalDepositLinkClickParams {
  analyticsOfferStatus: TAnalyticsOfferStatus;
  analyticsExtraOfferIds: IAnalyticsExtraOfferIds;
}

export const trackLegalDepositLinkClick = ({
  analyticsOfferStatus,
  analyticsExtraOfferIds,
}: ITrackLegalDepositLinkClickParams) => {
  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'click_pay_lk',
    label: 'balance',
    page: {
      extra: {
        ...analyticsExtraOfferIds,
      },
    },
  });
};
